import $ from 'jquery';
import LazyLoad from 'vanilla-lazyload';
import Swiper, { Autoplay, Lazy, Navigation } from 'swiper';
Swiper.use([Autoplay, Lazy, Navigation]);
export default class Supplements {
	constructor() {
		this.nav = $('.capsule__tab-link');
		this.columnLeftImg = $('.capsule__img-left');
		this.columnRightImg = $('.capsule__img-right');
		this.columnLeftDetails = $('.capsule__details--left');
		this.columnRightDetails = $('.capsule__details--right');
		this.supplementsLogo = $('.supplements__logo');
		this.supplementsQuote = $('.supplements__quote');
		this.ingredientDetailsButton = $('.ingredient__details');
		this.ingredientOverly = $('.ingredient__overlay');
		this.benefitSection = $('.supplement-benefit__grid');
		this.ingredientCarousel = '#ingredient';
		this.initFeedCarouselId = '#feed-carousel';
		this.lazyImg = new LazyLoad({
			elements_selector: '.swiper-slider img',
		});
		this.isActive = false;
	}

	init() {
		this.nav.on('click', (e) => {
			e.preventDefault();
			let dataTextReference = $(e.currentTarget).attr('href');
			dataTextReference = dataTextReference.replace('#', '');
			this.collectDataText(dataTextReference);
			this.nav.removeClass('capsule__tab-link--active');
			$(e.currentTarget).addClass('capsule__tab-link--active');
		});

		this.activeFirstData();

		this.benefitsSection();
	}

	collectDataText(dataReference) {
		const dataSelector = `data-${dataReference}`;
		const leftColumnData = this.columnLeftImg.attr(dataSelector);
		const rightColumnData = this.columnRightImg.attr(dataSelector);
		const dataText = {
			leftData: leftColumnData,
			rightData: rightColumnData,
		};

		this.updateData(dataText);
	}

	updateData(data) {
		this.columnLeftDetails.hide().fadeIn().text(data.leftData);
		this.columnRightDetails.hide().fadeIn().text(data.rightData);
	}

	activeFirstData() {
		this.nav.eq(0).addClass('capsule__tab-link--active');
		this.collectDataText('acid');
	}

	supplementsTab() {
		const self = this;
		var counter = 1,
			timer;
		this.supplementsLogo.each((index, el) => {
			$(el).on('click', function () {
				self.supplementsLogo.removeClass('supplements__logo--active');
				$(el).addClass('supplements__logo--active');
				self.supplementsQuote.hide();
				self.supplementsQuote.eq(index).fadeIn();
				counter = index + 1;
				clearInterval(timer);
				timer = setInterval(autoSupplementLogoLooping, 5000);
			});
		});

		timer = setInterval(autoSupplementLogoLooping, 5000);

		function autoSupplementLogoLooping() {
			var c = counter % $(self.supplementsLogo).length;
			self.supplementsLogo.removeClass('supplements__logo--active');
			self.supplementsLogo.eq(c).addClass('supplements__logo--active');
			self.supplementsQuote.hide();
			self.supplementsQuote.eq(c).fadeIn();
			++counter;
		}
	}

	incrementCounter(element, speed) {
		if (!$(element).length) return;
		var target = $(element),
			startNumber = parseInt(target.attr('data-start')),
			stopNumber = parseInt(target.attr('data-stop'));

		if (!target.hasClass('completed')) {
			var Count = setInterval(() => {
				startNumber = startNumber + 1;
				startNumber =
					startNumber >= stopNumber ? stopNumber : startNumber;
				if (startNumber == 100) {
					clearInterval(Count);
					target.addClass('completed');
				}
				$(target).text(startNumber);
			}, speed);
		}
	}

	InitCounterWatch() {
		const section = document.querySelector('#history-cta');

		let config = {
			rootMargin: '0px',
			threshold: 0,
		};

		let observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					this.incrementCounter('.history-cta__count', 15);
				}
			});
		}, config);
		if (section == null) return;
		observer.observe(section);
	}

	showIngredientsOverlay() {
		$(this.ingredientCarousel).on(
			'click',
			'.ingredient__details',
			(event) => {
				const current = $(event.currentTarget);
				current
					.parents('.swiper-slide')
					.siblings()
					.find('.ingredient')
					.removeClass('ingredient--active');
				current
					.parents('.ingredient')
					.toggleClass('ingredient--active');
			}
		);
	}

	initKeyIngredientCarousel() {
		var mySwiper,
			self = this,
			getLazy = this.loadLazyImg(),
			options = {
				spaceBetween: 54,
				loop: true,
				speed: 600,
				//autoHeight: true,
				breakpoints: {
					320: {
						slidesPerView: 1.45,
						spaceBetween: 15,
					},
					768: {
						slidesPerView: 3.35,
						spaceBetween: 28,
					},
				},
			};

		options = Object.assign(options, getLazy);

		function destroyKeyIngredientCarousel() {
			if ($(window).width() <= 1024) {
				if (typeof mySwiper == 'undefined') {
					mySwiper = new Swiper(self.ingredientCarousel, options);
				}
			} else {
				if (typeof mySwiper != 'undefined') {
					// destroy and delete swiper object
					mySwiper.destroy();
					mySwiper = undefined;

					// reset styling for wrapper and slides
					$(self.ingredientCarousel)
						.find('.swiper-wrapper')
						.removeAttr('style');
					$(self.ingredientCarousel)
						.find('.swiper-slide')
						.removeAttr('style');
				}
			}
		}
		destroyKeyIngredientCarousel();
		$(window).on('resize', () => {
			destroyKeyIngredientCarousel();
		});
	}

	initFeedCarousel() {
		var getLazy = this.loadLazyImg(),
			options = {
				slidesPerView: 3.1,
				spaceBetween: 0,
				speed: 500,
				autoplay: {
					delay: 3000,
					disableOnInteraction: true,
				},
				loop: true,
				infinite: true,
				breakpoints: {
					320: {
						slidesPerView: 1.276,
					},
					768: {
						slidesPerView: 3.07,
					},
				},
				navigation: {
					nextEl: '.swiper__cursor--right',
					prevEl: '.swiper__cursor--left',
				},
			};

		options = Object.assign(options, getLazy);
		new Swiper(this.initFeedCarouselId, options);
	}

	benefitsSection() {
		var benefitSectionScrollingAnimation = () => {
			if ($(window).width() >= 768 && $(window).width() < 992) {
				var benefitSectionScroll = 0,
					benefitScrollPositionHeight = (benefitSectionScroll =
						this.benefitSection.prop('scrollHeight'));

				setInterval(() => {
					benefitSectionScroll =
						benefitSectionScroll == 0
							? benefitScrollPositionHeight
							: benefitSectionScroll ==
							  benefitScrollPositionHeight
							? 0
							: 0;
					this.benefitSection.animate(
						{
							scrollTop: benefitSectionScroll,
						},
						1500
					);
				}, 4500);
			}
		};

		benefitSectionScrollingAnimation();

		$(window).on('resize', () => {
			benefitSectionScrollingAnimation();
		});
	}

	loadLazyImg() {
		var lazyImg = this.lazyImg,
			lazyOptions = {
				on: {
					init: function () {
						lazyImg.loadAll();
						lazyImg.update();
					},
				},
				lazy: {
					elementClass: 'swiper-lazy',
					loadPrevNext: true,
					loadPrevNextAmount: 2,
					loadPrevNextAmount: 2,
				},
			};
		return lazyOptions;
	}
}
